import { render, staticRenderFns } from "./Flame.vue?vue&type=template&id=17584839&scoped=true&"
var script = {}
import style0 from "./Flame.vue?vue&type=style&index=0&id=17584839&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17584839",
  null
  
)

export default component.exports